import { Component, OnInit, ViewChild, isDevMode } from '@angular/core'
import { ViewService, SelectorService, HttpService } from '../shared'
import { Subscription } from 'rxjs'
import { Title } from '@angular/platform-browser';
import { slideUp, slideRight } from '../shared/animations';


declare var jQuery: any;

@Component({
	selector: 'selector-component',
	template: require('./selector-gadget.component.html'),
	styles: [require('./selector-gadget.component.scss'), require('../app.component.scss')],
	providers: [SelectorService, ViewService, HttpService],
	animations: [ slideUp, slideRight ]
})

export class SelectorGadgetComponent implements OnInit {
	private selectors_count = 0;
	private export_result: any = '';
	private collection_name = 'Collection1';
	private busy: Subscription;
	private show_preview = false;
	private selecting = false;
	private activeTab = 'web';

	@ViewChild('previewcomponent') preview;
	@ViewChild('htmlcontainer') webview;
	@ViewChild('selectorlist') selectorview;

	constructor(private _selectorService: SelectorService, private _httpService: HttpService,
		private _viewService: ViewService, private title: Title) {
		/*this._router.events.subscribe(event =>{
			if(event instanceof NavigationEnd &&
				event.url==='/selector'&& event.urlAfterRedirects==='/selector'){
				this.selectors_count = this._selectorService.getSelectors().length;
				console.log(event);
			}
		});

		this._selectorService.setCollectionUrl(this._actRoute.snapshot.params['url']);*/
	}

	ngOnInit() {
		if (isDevMode()) {
			jQuery('#getstarted').load('./app-getting-started.html');
		} else {
			jQuery('#getstarted').load('./app-getting-started');
		}
		// window.history.pushState(null, document.title, "");
		this.title.setTitle('Scrape web sites. Save to JSON, CSV /Dataflow kit');
	}

	updateView() {
		this.show_preview = true;
		setTimeout(function() {
			jQuery('#web>a').trigger('click');
		}, 1);
	}

	onCollectionChanged(collection: any) {
		let active_tabs = jQuery('li.active');
		if (jQuery(active_tabs[0]).attr('id') === 'web') {
			if (this._httpService.current_url !== collection.url || collection.post_params.length > 0 ||
				(collection.url === '' && collection.action)) {
				this.webview.enable_panel = false;
				// this._httpService.current_url = collection.url;
				this.webview.onNavigate({url: collection.url, post_params: collection.post_params, action: collection.action});
			}
		} else {
			if (this._httpService.current_url !== 'http://' && (!this.selectorview.details_mode ||
				this.selectorview.current_collection.fields.length > 0 )) {
				this.preview.update(this.selectorview.current_collection);
			} else {
				this.updateView();
				this._viewService.activateWebTab();
			}
			this.webview.enable_panel = false;
			this.webview.onNavigate({url: collection.url, post_params: collection.post_params});
		}
	}

	onWebTabActivated() {
		if (this.selectorview.current_collection.request.url !== this._httpService.current_url) {
			this.webview.onNavigate({url: this.selectorview.current_collection.request.url});
		}
		this.activeTab = 'web';
	}

	onPreviewTabActivated() {
		this.activeTab = 'preview';
		this.preview.update(this.selectorview.current_collection);
	}

	onFormatChanged() {
		if (this.activeTab === 'preview') {
			this.preview.update(this.selectorview.current_collection);
		}
	}
}
